/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UiText { 
    /**
     * The message\'s context. Useful when customizing messages.
     */
    context?: object;
    id: number;
    /**
     * The message text. Written in american english.
     */
    text: string;
    /**
     * The message type. info Info error Error success Success
     */
    type: UiText.TypeEnum;
}
export namespace UiText {
    export type TypeEnum = 'info' | 'error' | 'success';
    export const TypeEnum = {
        Info: 'info' as TypeEnum,
        Error: 'error' as TypeEnum,
        Success: 'success' as TypeEnum
    };
}


